import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "../../assets/css/style.scss";
import CancelReservationModal from "./CancelReservationModal";
// import ParentReservationModal from "./ParentReservationModal";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { FaCalendarAlt } from "react-icons/fa";
import {
  getStatusBadge,
  getStatusText,
} from "../../component/admin/VehiclesTable";
import ParentReservationModal from "../../component/Model/reservation/ParentReservationModal";
import Tooltip from "../../component/Tooltip";
import { useGetAllReservationsQuery } from "../../store/api/parent/GetReservationSlice";
import {
  capitalizeString,
  formatDateToLocal,
} from "../../utils/dateAndTimeConversion";

import moment from "moment";
import AdminPagination from "../../component/pagination/AdminPagination";
import SkeletonLoading from "../../component/SkeletonLoading";

const initialPagination = {
  limit: 10,
  page: 1,
};
const initialDate = {
  startDate: null,
  endDate: null,
};

const initalFilters = {
  search: "",
  start_date: "",
  end_date: "",
  booking_type: "",
};

const Reservations = ({ status = null }) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [getAllReservation, setGetAllReservation] = useState([]);
  const [selectedInstance, setSelectedInstance] = useState(null);
  const [pagination, setPagination] = useState(initialPagination);
  const [filters, setFilters] = useState(initalFilters);
  const [date, setDate] = useState(initialDate);

  // const [searchTerm, setSearchTerm] = useState("");
  const { data, isSuccess, isLoading, isError, error, isFetching } =
    useGetAllReservationsQuery({
      page: pagination.page,
      limit: pagination.limit,
      ...filters,
    });

  const handleSearch = () => {
    setFilters((prev) => ({
      ...prev,
      search: search,
    }));

    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));
  };

  // Handle date change
  const handleDateChange = (dateType, value) => {
    // UI ke liye date state
    setDate((prev) => ({
      ...prev,
      [dateType]: value ? moment(value).format("YYYY-MM-DD") : null,
    }));

    // API filters ke liye
    setFilters((prev) => ({
      ...prev,
      [dateType === "startDate" ? "start_date" : "end_date"]: value
        ? moment(value).format("YYYY-MM-DD")
        : "",
    }));

    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit) => {
    setPagination((prev) => ({
      ...prev,
      limit,
      page: 1,
    }));
  };

  const handleBookingDetails = (item) => {
    setSelectedInstance(item);
    setShowDetailModal(true);
  };

  const handleCloseDetailModal = () => {
    setShowDetailModal(false);
    setSelectedInstance(null);
  };

  useEffect(() => {
    if (isSuccess && data?.data) {
      setGetAllReservation(data?.data?.instances || []);

      if (data?.data?.pagination) {
        setPagination(data.data.pagination);
      }
    }
  }, [data, isSuccess]);

  useEffect(() => {
    if (status) {
      setFilters((prev) => ({
        ...prev,
        status,
      }));
    }
  }, [status]);

  const handleReset = () => {
    setFilters(initalFilters);
    setDate(initialDate);
    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap w-100 mb-2">
        <div className="total">
          {t("total")} {t("reservations")}: {pagination?.total}
        </div>

        <div className="d-flex flex-wrap gap-2 ms-auto">
          <div className="d-flex flex-grow-1">
            <select
              className="form-select"
              value={filters.booking_type}
              onChange={(e) =>
                setFilters((prev) => ({
                  ...prev,
                  booking_type: e.target.value,
                }))
              }
            >
              <option value="">
                {t("select")} {t("booking")} {t("type")}
              </option>
              <option value="busing_subscription">
                {t("busing")} {t("subscriptions")}
              </option>
              <option value="bus_charter">
                {t("bus")} {t("charter")} {t("reservations")}
              </option>
            </select>
          </div>
          <div className="d-flex flex-grow-1">
            <div className="position-relative w-100">
              <DatePicker
                className="form-control"
                selected={
                  date.startDate
                    ? moment(date.startDate, "YYYY-MM-DD").toDate()
                    : null
                }
                onChange={(selectedDate) =>
                  handleDateChange("startDate", selectedDate)
                }
                selectsStart
                startDate={
                  date.startDate
                    ? moment(date.startDate, "YYYY-MM-DD").toDate()
                    : null
                }
                endDate={
                  date.endDate
                    ? moment(date.endDate, "YYYY-MM-DD").toDate()
                    : null
                }
                dateFormat="yyyy-MM-dd"
                placeholderText={`${t("select")} ${t("start")} ${t("date")}`}
              />

              <FaCalendarAlt className="calederIcon" />
            </div>
          </div>
          <div className="d-flex flex-grow-1">
            <div className="position-relative w-100">
              <DatePicker
                className="form-control"
                selected={
                  date.endDate
                    ? moment(date.endDate, "YYYY-MM-DD").toDate()
                    : null
                }
                onChange={(selectedDate) =>
                  handleDateChange("endDate", selectedDate)
                }
                selectsEnd
                startDate={
                  date.startDate
                    ? moment(date.startDate, "YYYY-MM-DD").toDate()
                    : null
                }
                endDate={
                  date.endDate
                    ? moment(date.endDate, "YYYY-MM-DD").toDate()
                    : null
                }
                minDate={
                  date.startDate
                    ? moment(date.startDate, "YYYY-MM-DD").toDate()
                    : null
                }
                dateFormat="yyyy-MM-dd"
                placeholderText={`${t("select")} ${t("end")} ${t("date")}`}
                disabled={!date.startDate}
              />

              <FaCalendarAlt className="calederIcon" />
            </div>
          </div>

          <div className="d-flex gap-2 ms-auto">
            <button className="btn btn-primary addDriver" onClick={handleReset}>
              {t("btns.reset")}
            </button>
          </div>
        </div>
      </div>

      <div className="table m-0">
        <table>
          <thead>
            <tr>
              <th>
                {t("Sr")}.{t("no")}.
              </th>
              <th>{t("date")}</th>
              <th>
                {t("trip")} {t("leg")}
              </th>
              <th>{t("status")}</th>
              <th>
                {t("available")} {t("seats")}
              </th>
              <th>{t("Booking Type")}</th>
              <th>{t("action")}</th>
            </tr>
          </thead>
          <tbody>
            {isLoading || isFetching ? (
              <SkeletonLoading MainLength={10} length={7} />
            ) : isError ? (
              <tr>
                <td colSpan="7" className="text-center text-danger">
                  {t("error")}: {error?.message || "Failed to load data"}
                </td>
              </tr>
            ) : getAllReservation?.length > 0 ? (
              getAllReservation.map((item, index) => {
                const instance = item?.instance;
                return (
                  <tr key={instance?.id || index}>
                    <td>
                      {(pagination.page - 1) * pagination.limit + index + 1}
                    </td>
                    <td>{formatDateToLocal(instance?.date)}</td>
                    <td>
                      {instance?.trip_leg ? (
                        <span
                          className={`badge ${instance.trip_leg === "return" ? "bg-warning text-dark" : "bg-success"}`}
                        >
                          {instance.trip_leg === "return"
                            ? "School to Home"
                            : "Home to School"}
                        </span>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td>
                      <span className={getStatusBadge(instance?.status)}>
                        {getStatusText(instance?.status)}
                      </span>
                    </td>
                    <td>{instance?.available_seats || 0}</td>
                    <td>
                      {item?.reservation?.booking_type
                        ? capitalizeString(item?.reservation?.booking_type)
                        : ""}
                    </td>
                    <td>
                      <div className="actionBtn d-flex">
                        <Tooltip title={`${t("reservation")} ${t("details")}`}>
                          <Button
                            className="rounded-circle iconBtn me-2"
                            onClick={() => handleBookingDetails(item)}
                          >
                            <svg
                              id="Group_3073"
                              data-name="Group 3073"
                              xmlns="http://www.w3.org/2000/svg"
                              width="22.592"
                              height="22.592"
                              viewBox="0 0 22.592 22.592"
                            >
                              <path
                                id="calendar-check"
                                d="M17.886,1.883h-.941V.941a.941.941,0,0,0-1.883,0v.941H7.531V.941a.941.941,0,1,0-1.883,0v.941H4.707A4.712,4.712,0,0,0,0,6.589v11.3a4.712,4.712,0,0,0,4.707,4.707H17.886a4.712,4.712,0,0,0,4.707-4.707V6.589A4.712,4.712,0,0,0,17.886,1.883ZM4.707,3.765H17.886A2.827,2.827,0,0,1,20.71,6.589v.941H1.883V6.589A2.827,2.827,0,0,1,4.707,3.765ZM17.886,20.71H4.707a2.827,2.827,0,0,1-2.824-2.824V9.413H20.71v8.472A2.827,2.827,0,0,1,17.886,20.71Z"
                                fill="#727782"
                              />
                              <g
                                id="refresh"
                                transform="translate(6.776 10.498)"
                              >
                                <path
                                  id="Path_1637"
                                  data-name="Path 1637"
                                  d="M3.591,4.063a3.425,3.425,0,0,1,5.615-2.1L8.764,2.4a.379.379,0,0,0,.268.647H10.77a.379.379,0,0,0,.379-.379V.931A.379.379,0,0,0,10.5.663l-.493.493A4.557,4.557,0,0,0,2.469,3.9a.567.567,0,1,0,1.122.166Z"
                                  transform="translate(-2.461 0)"
                                  fill="#727782"
                                />
                                <path
                                  id="Path_1638"
                                  data-name="Path 1638"
                                  d="M30.356,256.891a.574.574,0,0,0-.563.5,3.425,3.425,0,0,1-5.615,2.1l.441-.441a.379.379,0,0,0-.268-.647H22.614a.379.379,0,0,0-.379.379v1.738a.379.379,0,0,0,.647.268l.493-.493a4.556,4.556,0,0,0,7.541-2.742.574.574,0,0,0-.474-.659A.555.555,0,0,0,30.356,256.891Z"
                                  transform="translate(-21.884 -252.328)"
                                  fill="#727782"
                                />
                              </g>
                            </svg>
                          </Button>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  {t("no")} {t("data")} {t("found")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <AdminPagination
        totalPages={pagination.totalPages}
        currentPage={pagination.page}
        limit={pagination.limit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
      />

      {/* Cancel Reservation Modal */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        aria-labelledby="cancel-reservation-modal"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="cancel-reservation-modal">
            {t("multiple")} {t("cancellation")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <CancelReservationModal show={showModal} onClose={handleCloseModal} />
        </Modal.Body>
      </Modal>

      {/* Reservation Details Modal */}
      <ParentReservationModal
        show={showDetailModal}
        onClose={handleCloseDetailModal}
        instance={selectedInstance}
      />
    </>
  );
};

export default Reservations;
